// extracted by mini-css-extract-plugin
export default {"content_body_background":"KJuHCe6lnab9cJ1Gu2UM"};